module.exports = __webpack_public_path__ + "img/tour-53.041a10c1.png";